var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51801 3.9826C9.76184 3.7387 10.0926 3.60164 10.4374 3.60156H15.1009C15.4458 3.60156 15.7766 3.73858 16.0205 3.98246C16.2644 4.22634 16.4014 4.55712 16.4014 4.90203V9.56549C16.4013 9.91037 16.2642 10.2411 16.0203 10.4849L10.3607 16.1445C10.0652 16.4382 9.66545 16.603 9.24881 16.603C8.83217 16.603 8.43246 16.4382 8.13692 16.1445L3.85839 11.866C3.56471 11.5705 3.39989 11.1708 3.39989 10.7541C3.39989 10.3375 3.56471 9.93776 3.85839 9.64222L9.51801 3.9826Z",
    stroke: "#64748B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.23193,
    cy: 1.23193,
    r: 1.23193,
    transform: "matrix(-1 0 0 1 13.665 6.45312)",
    stroke: "#64748B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFieldIcon);
export default __webpack_public_path__ + "static/media/custom-field-icon.d70c431332b700f515b02410f6efc3c1.svg";
export { ForwardRef as ReactComponent };